import GameLogsContainer from './gameLogs'

export default GameLogsContainer